import { Base } from './Base';
import { Edge } from '../Models/Nodes/Edge';

export class Nodes extends Base
{
    public getEdgeClient(ip=null, port=null)
    {
    	var rObj	= new Edge();
    	rObj.setAuto(this.getAuto()).setConfiguration(ip, port);
    	rObj.setErrorCb(this, "defaultErrorHandler"); //replace with your own
    	return rObj;
    }
    public defaultErrorHandler(e)
	{
    	console.log("Default Node Factory Error Handler");
    	console.log("Start Error");
    	console.log(e);
    	console.log("End Error");
    	console.log("Message: '" + e.getMessage() + "', code: '" + e.getCode() + "'");
    	console.log(e.stack);
	}
}